import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from "../actions/user";
import apiCall from "@/api/apiCall";
import { apiUrl } from "@/api/apiUrl";
import Vue from "vue";
import { AUTH_LOGOUT, AUTH_REQUEST } from "../actions/auth";
import route from "../../router/index.js";

const state = {
  status: "",
  profile:
    !localStorage.getItem("map-user") ||
    localStorage.getItem("map-user") == "undefined"
      ? null
      : JSON.parse(localStorage.getItem("map-user"))
};

const mutations = {
  [USER_REQUEST]: state => {
    state.status = "loading";
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = "success";
    state.profile = {
      ...resp
    };
  },
  [USER_ERROR]: state => {
    state.status = "error";
  },
  [AUTH_LOGOUT]: state => {
    state.profile = {};
  }
};

const actions = {
  [USER_REQUEST]: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      let host = "";
      let path = "/";
      let origin = window.location.origin;

      const verify = {
        'bo-stage.mapcard.pro': "https://auth-stage.mapcard.pro",
        'bo-evo.mapcard.pro': "https://auth-evo.mapcard.pro",
        'cabinet-stage.rocketpay.kz ': "https://auth-stage.mapcard.pro",
        'cabinet.rocketpay.kz': "https://auth-evo.mapcard.pro",
      }

      host = verify[window.location.hostname] || "https://auth-stage.mapcard.pro"
      // if (/bo-dev|localhost/.test(origin)) {
      //   host = "http://localhost:3001";
      //   //path = apiUrl.match(/\/(feature-.*|develop)\//)[0];
      //   path = "/"
      // }
      //
      // if (/bo-fix/.test(origin)) host = "https://auth-fix.mapcard.pro";
      // if (/bo-stage/.test(origin)) host = "https://auth-stage.mapcard.pro";
      // if (/bo-evo/.test(origin)) host = "https://auth-evo.mapcard.pro";
      
      commit(AUTH_REQUEST);
      apiCall({
        url: host + path + "verify-auth"
      })
        .then(resp => {
          commit(USER_SUCCESS, resp.user);
          resolve(resp);
        })
        .catch(err => {
          console.log(err);
          commit(USER_ERROR);
          dispatch(AUTH_LOGOUT);
          reject(err);
        });
    });
  }
};

const getters = {
  isAuthenticated: state => {
    return !!state.profile;
  },
  getProfile: state => state.profile,
  getStatus: state => {
    return state.loading;
  },
  getUserName: state => {
    if (state.profile) {
      let name =
        state.profile["full_name"] != null
          ? state.profile["full_name"]
          : state.profile.login;
      if (name != undefined) return name;
      else return "";
    } else return "";
  },
  getRights: state => {
    if (state.profile != undefined && state.profile.rights != null) {
      let rights = state.profile.rights;
      if (rights != undefined) return rights;
      else return [];
    } else return [];
  },
  hasRight: state => right => {
    if (!state.profile || !state.profile.rights) {
      return false
    }
    return ~state.profile.rights.indexOf(right)
  },
  getInitials: state => {
    if (state.profile != undefined) {
      let name =
        state.profile["full_name"] != null
          ? state.profile["full_name"]
          : state.profile.login;
      if (name != undefined)
        return name
          .split(" ")
          .map(el => el[0])
          .join("")
          .toUpperCase();
      else return "";
    } else return "";
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
